import type { ReactElement, SVGProps } from "react";

/** Bare checkmark for the use-case landing pages — sizing/stroke/color come
 *  entirely from the page's own CSS (`.ucx .wp-step .st svg`). */
export function UseCaseCheckIcon(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg viewBox="0 0 24 24" {...props}>
      <path d="m5 13 4 4L19 7.5" />
    </svg>
  );
}
